
import { Component, Vue, Ref, Inject } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'

@Observer
@Component({
  scrollToTop: false
})
export default class UnBindWx extends Vue {
  get PageStore() {
    return this.$store.$storeUser
  }

  onCancel() {
    this.PageStore.onChangeBindVisible(false)
  }

  async onOk() {
    try {
      const res = await this.PageStore.onUnbindwechat()

      if (res === true) {
        this.$msg('解绑成功')
      }

      this.PageStore.onChangeBindVisible(false)
      await this.PageStore.onGetUserInfo()
    } catch (error) {
      console.log('Clin -> file: change_wx.vue -> line 45 -> PageView -> bindWx -> error', error)
    }
  }

  created() {}
}
